'use client';

import React, { useState } from 'react';
import { DollarSign } from 'lucide-react';
import { useCurrency } from '@/context/CurrencyContext';
import CurrencyModal from '@/components/CurrencyModal';

/**
 * Botón global del topbar para consultar y editar el tipo de cambio.
 * Vive dentro de <CurrencyProvider> y abre el modal compartido.
 */
const CurrencyRateButton = () => {
    const { rates } = useCurrency();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setIsOpen(true)}
                className="flex items-center gap-1.5 px-2 sm:px-2.5 py-1.5 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"
                title={`Tipo de cambio global — Compra Q${rates.BUY_EXCHANGE_RATE} / Venta Q${rates.SELL_EXCHANGE_RATE}`}
                aria-label="Configurar tipo de cambio global"
            >
                <DollarSign size={16} />
                <span className="hidden md:inline text-[11px] font-bold tabular-nums">
                    Q{rates.SELL_EXCHANGE_RATE}
                </span>
            </button>
            <CurrencyModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
};

export default CurrencyRateButton;
